module.exports = __webpack_public_path__ + "static/media/35-5.8b61e68a.mp3";